
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { CommonSerivce } from '../shared/services/common.service';
import { UserService } from '../shared/services/user.service';
import { FormsModule } from '@angular/forms';

import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import * as _ from 'underscore';

import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'navmenu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.css'],
  providers: [CommonSerivce, UserService]
})
export class NavMenuComponent implements OnInit, OnDestroy {
  SecApiPath: string = "api/BcpUserSecurityAppl/ByUser/";
  public ProgramList: any[];

  //Menu Item Display control flag

  USER_PROFILE: boolean = false;
  LIST_VALUE: boolean = false;
  CASE: boolean = false;
  COUNTERx: boolean = false;
  ETSTENDER: boolean = false;
  ETSPROJECT: boolean = false;
  ETSREPORT: boolean = false;
  COMPANY: boolean = false;
  CONTACT: boolean = false;
  REPORT: boolean = false;



  //Other variables

  status: boolean;
  subscription: Subscription;
  httpHeaders = new HttpHeaders();

  showLoginInfo: boolean = true;
  domainId: string;
  loginUser: string;
  dataRole: string;
  processRole: string;
  actionRole: string;

  constructor(private userService: UserService, private http: HttpClient, private bcp: CommonSerivce, private router: Router) {
    this.httpHeaders = this.bcp.getHttpHeader();
  }

  ngOnInit() {
    console.log("NAV MENU ngOnInit");

    this.http.get("api/BcpUserSecurityAppl/ByUser/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentLoginUser(), { headers: this.bcp.getHttpHeader() })
      .subscribe((result: any) => {
        this.ProgramList = result;

        this.domainId = this.bcp.getCurrentDomainId().toUpperCase();
        this.loginUser = this.bcp.getCurrentLoginUser().toUpperCase();
        this.dataRole = this.bcp.getCurrentDataRole();
        this.processRole = this.bcp.getCurrentProcessRole();
        this.actionRole = this.bcp.getCurrentActionRole();

      for (var i = 0; i < this.ProgramList.length; i++) {
        var data = this.ProgramList[i];
        if (data.process == 'USER_PROFILE' && data.allowAccess == 'Y') {
          this.USER_PROFILE = true;
        }
        if (data.process == 'LIST_VALUE' && data.allowAccess == 'Y') {
          this.LIST_VALUE = true;
        }
        if (data.process == 'CASE' && data.allowAccess == 'Y') {
          this.CASE = true;
        }
        if (data.process == 'ETSTENDER' && data.allowAccess == 'Y') {
          this.ETSTENDER = true;
        }
        if (data.process == 'ETSPROJECT' && data.allowAccess == 'Y') {
          this.ETSPROJECT = true;
        }
        if (data.process == 'ETSREPORT' && data.allowAccess == 'Y') {
          this.ETSREPORT = true;
        }
        if (data.process == 'COMPANY' && data.allowAccess == 'Y') {
          this.COMPANY = true;
        }
        if (data.process == 'CONTACT' && data.allowAccess == 'Y') {
          this.CONTACT = true;
        }
        if (data.process == 'REPORT' && data.allowAccess == 'Y') {
          this.REPORT = true;
        }

        this.COUNTERx = false;

        sessionStorage.setItem(data.process, data.accessRight);
        
      }
      });
    console.log("NAV MENU" + sessionStorage);
  }

  ngOnDestroy() {
  }


}


